import React from 'react';

import {LegacyAssaySchemaType} from 'graphql-client/__generated/graphqlGlobalTypes';
import AssaySchemaEditor from 'results/assay-schemas/AssaySchemaEditor';

export default function RunSchemaEditor(props: {schemaId?: string}): JSX.Element {
  return (
    <AssaySchemaEditor
      schemaId={props.schemaId}
      schemaType={LegacyAssaySchemaType.ASSAY_RUN}
      autosave={false}
      baseTestAttrs={{component: 'RunSchemaEditor'}}
      publishDefaultDataTableConfig={false}
    />
  );
}
